// extracted by mini-css-extract-plugin
module.exports = {"back":"PreviousPageMobile_back__3s13z"};